(function(){
  function money(c){ if(c==null||isNaN(c)) return ''; return '$'+(c/100).toFixed(2); }
  function init(root){
    var form = root.querySelector('form.e-form') || root.querySelector('form');
    var idInput = root.querySelector('[data-variant-id]');
    var opts = Array.prototype.slice.call(root.querySelectorAll('.e-opt'));
    var priceCur = root.querySelector('[data-price-current]');
    var priceCmp = root.querySelector('[data-price-compare]');
    var priceSave = root.querySelector('[data-price-save]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');

    function select(opt){
      opts.forEach(function(o){
        var on = o === opt;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        var r = o.querySelector('input[type=radio]'); if(r) r.checked = on;
      });
      var id = opt.getAttribute('data-variant-id');
      var price = parseInt(opt.getAttribute('data-price') || '0', 10);
      var cmp = parseInt(opt.getAttribute('data-compare') || '0', 10);
      if(idInput) idInput.value = id;
      if(priceCur) priceCur.textContent = money(price);
      if(priceCmp){ if(cmp > price){ priceCmp.textContent = money(cmp); priceCmp.style.display=''; } else { priceCmp.style.display='none'; } }
      if(priceSave){ if(cmp > price){ priceSave.textContent = 'Save ' + money(cmp - price); priceSave.style.display=''; } else { priceSave.style.display='none'; } }
      if(stickyPrice) stickyPrice.textContent = money(price);

      // swap the main gallery image to the selected option's image
      var mImg = root.querySelector('[data-main-img]');
      var mPh = root.querySelector('[data-main-ph]');
      var sl = root.querySelectorAll('[data-eslide]');
      var th = root.querySelectorAll('[data-ethumb]');
      if(mImg){
        var oi = opt.getAttribute('data-opt-image') || '';
        var def = mImg.getAttribute('data-default') || '';
        var use = oi || def;
        if(use){ mImg.src = use; mImg.style.display = ''; if(mPh) mPh.style.display = 'none'; }
        else {
          mImg.style.display = 'none';
          if(mPh){ mPh.style.display = ''; var nm = opt.querySelector('.e-opt-name'); mPh.textContent = '[ ' + (nm ? nm.textContent.toUpperCase() : 'PRODUCT') + ' — ADD IMAGE ]'; }
        }
        for(var k = 0; k < sl.length; k++){ sl[k].style.display = k === 0 ? '' : 'none'; }
        for(var m = 0; m < th.length; m++){ th[m].classList.toggle('is-active', m === 0); }
      }
    }
    opts.forEach(function(o){
      o.addEventListener('click', function(){ select(o); });
      o.addEventListener('keydown', function(e){ if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); select(o); } });
    });
    var initSel = root.querySelector('.e-opt.is-selected');
    if(initSel){ select(initSel); }

    var qty = root.querySelector('[data-qty-input]');
    function q(){ return Math.max(1, parseInt((qty && qty.value) || '1', 10) || 1); }
    var dec = root.querySelector('[data-qty-dec]'), inc = root.querySelector('[data-qty-inc]');
    if(dec) dec.addEventListener('click', function(){ if(qty) qty.value = Math.max(1, q() - 1); });
    if(inc) inc.addEventListener('click', function(){ if(qty) qty.value = q() + 1; });

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var id = idInput ? idInput.value : null;
        if(!id){ form.submit(); return; }
        if(atc){ atc.disabled = true; } if(atcLabel){ atcLabel.dataset._t = atcLabel.textContent; atcLabel.textContent = 'Adding…'; }
        fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items:[{ id: parseInt(id,10), quantity: q() }] }) })
        .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
        .then(function(){ window.location = '/cart'; })
        .catch(function(){ if(atc){ atc.disabled = false; } if(atcLabel && atcLabel.dataset._t){ atcLabel.textContent = atcLabel.dataset._t; } form.submit(); });
      });
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-acc-h]')).forEach(function(h){
      h.addEventListener('click', function(){
        var it = h.closest('[data-acc]'); if(it) it.classList.toggle('open');
        var open = h.getAttribute('aria-expanded') === 'true';
        h.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ethumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-eslide]'));
    thumbs.forEach(function(t, i){
      t.addEventListener('click', function(){
        slides.forEach(function(s, si){ s.style.display = si === i ? '' : 'none'; });
        thumbs.forEach(function(x, xi){ x.classList.toggle('is-active', xi === i); });
      });
    });

    var buy = root.querySelector('[data-buy]');
    var sticky = document.querySelector('[data-sticky]');
    if(buy && sticky){
      function onScroll(){ var r = buy.getBoundingClientRect(); sticky.classList.toggle('show', r.bottom < 60); }
      window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
      var sb = sticky.querySelector('[data-sticky-atc]');
      if(sb && atc){ sb.addEventListener('click', function(){ atc.click(); }); }
    }
  }
  function boot(){ Array.prototype.slice.call(document.querySelectorAll('[data-vergo]')).forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
